"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Builder", {
  enumerable: true,
  get: function get() {
    return _Builder.Builder;
  }
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player.Player;
  }
});
Object.defineProperty(exports, "builderFields", {
  enumerable: true,
  get: function get() {
    return _settings.fields;
  }
});
Object.defineProperty(exports, "builderInitialValues", {
  enumerable: true,
  get: function get() {
    return _settings.initialValues;
  }
});
Object.defineProperty(exports, "builderValidate", {
  enumerable: true,
  get: function get() {
    return _settings.validate;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getDataDefinitions", {
  enumerable: true,
  get: function get() {
    return _settings.getDataDefinitions;
  }
});
Object.defineProperty(exports, "getMetrics", {
  enumerable: true,
  get: function get() {
    return _settings.getMetrics;
  }
});
Object.defineProperty(exports, "getMetricsPrefix", {
  enumerable: true,
  get: function get() {
    return _settings.getMetricsPrefix;
  }
});
Object.defineProperty(exports, "icon", {
  enumerable: true,
  get: function get() {
    return _settings.icon;
  }
});
Object.defineProperty(exports, "playerValidate", {
  enumerable: true,
  get: function get() {
    return _settings2.validate;
  }
});
Object.defineProperty(exports, "ttsFields", {
  enumerable: true,
  get: function get() {
    return _settings.ttsFields;
  }
});
var _Builder = _interopRequireWildcard(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireWildcard(require("./Player"));
var _settings2 = require("./Player/settings.js");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// export these data for matrix
var _default = {
  code: 'openEnded',
  name: 'Open Ended',
  labelField: 'question',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  getPlayerInitialValue: _settings2.getInitialValue,
  getMetricsPrefix: _settings.getMetricsPrefix,
  getDataDefinitions: _settings.getDataDefinitions,
  getMetrics: _settings.getMetrics,
  getDataConnectors: _settings.getDataConnectors,
  getDataConnectorsValues: _settings.getDataConnectorsValues,
  ttsFields: _settings.ttsFields,
  isSkipped: _settings.isSkipped,
  getTotalQuestionNumbers: function getTotalQuestionNumbers() {
    return 1;
  },
  hasPrintVersion: true
};
exports["default"] = _default;